// extracted by mini-css-extract-plugin
export default {"login-form-container":"components_login-form-container__cwq9Q","login-form":"components_login-form__rBgae"};